module.exports = __webpack_public_path__ + "images/unive_smalla05430aae281fa9333e0a9b6e906b2da.png";